import React from 'react'
import {MenuItem, FlatButton, Dialog} from 'material-ui'

class DeleteDialog extends React.Component {

	render() {
		const {onDeleteClick, history, dialogTitle} = this.props
		const id = this.props.match.params.id
		const actions = [
			<FlatButton
				label="No"
				onTouchTap={() => {
					history.goBack()
				}}
			/>,
			<FlatButton
				label="Yes"
				primary={true}
				onTouchTap={() => {
					onDeleteClick(id)
					history.goBack()
				}}
			/>
		];
		return (
			<Dialog 
				title={dialogTitle}
				actions={actions}
				modal={true}
				open={true}
				autoScrollBodyContent={true}>
				<div>Are you sure to delete this record?</div>
			</Dialog>
		)
	}
}

export default DeleteDialog


// WEBPACK FOOTER //
// ./src/components/DeleteDialog.js